import { Minus, Plus } from "lucide-react";
import React from "react";

export const GuestsPopup = ({ adults, setAdults, kids, setKids, onClose }) => {
  return (
    <div className="fixed inset-0 z-[999] flex items-end sm:items-center justify-center  ">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />

      <div
        className="relative w-full sm:w-[360px]
        rounded-t-2xl sm:rounded-2xl
        bg-white shadow-xl border border-black/10
        p-5 sm:p-6 z-10
        max-h-[90vh] overflow-y-auto"
      >
        <div className="flex items-center justify-between">
          <p className="text-[14px] sm:text-[15px] font-semibold text-[#1F2226]">
            Add Guests
          </p>

          <button
            type="button"
            onClick={onClose}
            className="h-8 w-8 grid place-items-center rounded-full hover:bg-black/5"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <RowCounter
          title="Adults"
          sub="Age 18+"
          value={adults}
          onMinus={() => setAdults((v) => Math.max(1, v - 1))}
          onPlus={() => setAdults((v) => v + 1)}
        />

        <RowCounter
          title="Children"
          sub="Age 0–17"
          value={kids}
          onMinus={() => setKids((v) => Math.max(0, v - 1))}
          onPlus={() => setKids((v) => v + 1)}
        />

        <div className="mt-6 sm:mt-8">
          <button
            type="button"
            onClick={onClose}
            className="w-full py-3 rounded-xl
              bg-primary text-white
              text-[14px] sm:text-[15px]
              font-semibold hover:opacity-90 transition"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

const RowCounter = ({ title, sub, value, onMinus, onPlus }) => {
  return (
    <div className="mt-5 sm:mt-6 flex items-center justify-between">
      <div>
        <p className="text-[14px] sm:text-[15px] font-semibold text-[#1F2226]">
          {title}
        </p>
        <p className="text-[12px] text-[#9AA3AE]">{sub}</p>
      </div>

      <div className="flex items-center gap-3">
        <CircleBtn onClick={onMinus}><Minus/></CircleBtn>

        <p className="w-6 text-center text-[14px] font-semibold text-[#1F2226]">
          {value}
        </p>

        <CircleBtn onClick={onPlus} variant="blue">
          <Plus/>
        </CircleBtn>
      </div>
    </div>
  );
};

const CircleBtn = ({ children, onClick, variant }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`h-9 w-9 sm:h-10 sm:w-10 rounded-full
        grid place-items-center border transition
        ${
          variant === "blue"
            ? "border-primary text-primary hover:bg-[#1D6DFF]/5"
            : "border-black/10 text-[#1F2226] hover:bg-black/5"
        }`}
    >
      {children}
    </button>
  );
};
